import styled from "styled-components";

export const Wrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
`;

export const Times = styled.div`
  position: absolute;
  top: 0;
  left: 0;
`;
